import {
  GET_SCHEDULED_LIST,
  GET_SCHEDULED_LIST_SUCCESS,
  GET_SCHEDULED_LIST_FAIL,
  GET_SCHEDULED_DETAIL,
  GET_SCHEDULED_DETAIL_SUCCESS,
  GET_SCHEDULED_DETAIL_FAIL,
  CANCEL_SCHEDULED,
  CANCEL_SCHEDULED_SUCCESS,
  CANCEL_SCHEDULED_FAIL,
  FREEZE_SCHEDULED,
  FREEZE_SCHEDULED_SUCCESS,
  FREEZE_SCHEDULED_FAIL,
  RESET_SCHEDULED_FLAG,
} from "./actionTypes"

export const getScheduledList = (payload) => ({
  type: GET_SCHEDULED_LIST,
  payload,
})

export const getScheduledListSuccess = (data) => ({
  type: GET_SCHEDULED_LIST_SUCCESS,
  payload: data,
})

export const getScheduledListFail = (error) => ({
  type: GET_SCHEDULED_LIST_FAIL,
  payload: error,
})

export const getScheduledDetail = (id) => ({
  type: GET_SCHEDULED_DETAIL,
  payload: id,
})

export const getScheduledDetailSuccess = (data) => ({
  type: GET_SCHEDULED_DETAIL_SUCCESS,
  payload: data,
})

export const getScheduledDetailFail = (error) => ({
  type: GET_SCHEDULED_DETAIL_FAIL,
  payload: error,
})

export const cancelScheduled = (id) => ({
  type: CANCEL_SCHEDULED,
  payload: id,
})

export const cancelScheduledSuccess = (id) => ({
  type: CANCEL_SCHEDULED_SUCCESS,
  payload: id,
})

export const cancelScheduledFail = (error) => ({
  type: CANCEL_SCHEDULED_FAIL,
  payload: error,
})

export const freezeScheduled = (id) => ({
  type: FREEZE_SCHEDULED,
  payload: id,
})

export const freezeScheduledSuccess = (data) => ({
  type: FREEZE_SCHEDULED_SUCCESS,
  payload: data,
})

export const freezeScheduledFail = (error) => ({
  type: FREEZE_SCHEDULED_FAIL,
  payload: error,
})

// Reset the transient "just cancelled / just frozen" flags once the page reacts.
export const resetScheduledFlag = () => ({
  type: RESET_SCHEDULED_FLAG,
})
